import { RefObject, useEffect } from "react";
type HeightCallback = (height: number) => void;

const useElementHeight = (
  callback: HeightCallback,
  ref: RefObject<HTMLElement>
) => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        callback(entry.contentRect.height as number);
      }
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
      resizeObserver.disconnect();
    };
  }, [ref, callback]);
};

export default useElementHeight;
